import { EmployeeDTOCivilStatusEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { calculateRecreationBudget } from 'probonio-shared-ui/utils/calculateRecreationBudget';

export function useRecreationMaxBudget(civilStatus: EmployeeDTOCivilStatusEnum, numberOfKids: number): number {
  const { tenant } = useTenant();

  if (!tenant?.taxConfig) {
    return 0;
  }

  return calculateRecreationBudget(civilStatus, numberOfKids, tenant.taxConfig);
}
